module.exports = {
      id: "icons:question-circle-usage",
      viewBox: "0 0 24 24",
      url: "/static/" + "sprites.1e5806fb7235408b9281f0924c9110c8.svg#icons:question-circle-usage",
      toString: function () {
        return this.url;
      }
    }